import "./SideBar.css";
import { motion } from "framer-motion";
import { ReactComponent as Cross } from "../../shared/cross.svg";
import { Link, useNavigate } from "react-router-dom";
import { ReactComponent as Logo } from "../../shared/logo.svg";
import { useTranslation } from "react-i18next";

export default function SideBar({ open, onClose }: any) {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();

  const changeLanguageHandler = (lang: string) => {
    i18n.changeLanguage(lang);
  };

  return open ? (
    <div onClick={onClose} className="sidebar-outer">
      <motion.div
        initial={{ x: 300 }}
        animate={{ x: 0, transition: { duration: 0.3 } }}
        className="sidebar"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="sidebar-top">
          <div className="sidebar-header">
            <button aria-label="Close Sidebar" onClick={onClose}>
              <Cross />
            </button>
          </div>
          <div className="sidebar-content">
            <button
              onClick={() => {
                onClose();
                if (window.location.pathname !== "/") {
                  navigate("/");
                }
                document.getElementById("home")?.scrollIntoView();
              }}
              className="header-link"
              style={{ fontSize: "22px" }}
            >
              {t("header_home")}
            </button>
            <button
              onClick={() => {
                onClose();
                if (window.location.pathname !== "/") {
                  navigate("/");
                }
                document.getElementById("products")?.scrollIntoView();
              }}
              className="header-link"
              style={{ fontSize: "22px" }}
            >
              {t("header_products")}
            </button>
            <button
              onClick={() => {
                onClose();
                if (window.location.pathname !== "/") {
                  navigate("/");
                }
                document.getElementById("contacts")?.scrollIntoView();
              }}
              className="header-link"
              style={{ fontSize: "22px" }}
            >
              {t("header_contact")}
            </button>
            <div
              style={{
                marginTop: "10px",
                paddingTop: "10px",
                borderTop: "solid 1px #243b4b",
              }}
              className="header-side"
            >
              <label style={{ fontSize: "22px" }} className="header-link">
                {t("header_language")}
              </label>
              <select
                className="select"
                name="selectedFilter"
                onChange={(e) => changeLanguageHandler(e.target.value)}
                defaultValue={i18n.language}
              >
                <option className="header-link option" value="en">
                  English
                </option>
                <option className="header-link" value="ru">
                  Русский
                </option>
                <option className="header-link" value="es">
                  Español
                </option>
                <option className="header-link" value="pt">
                  Português
                </option>
              </select>
            </div>
          </div>
        </div>
        <div className="sidebar-bottom">
          <Link to="/privacy-policy" className="header-link">
            Privacy Policy
          </Link>
          <Logo />
        </div>
      </motion.div>
    </div>
  ) : null;
}
